/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const SearchIcon = createIcon({
  displayName: "SearchIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.56261 3.5C6.38799 3.5 4.62511 5.26288 4.62511 7.4375C4.62511 8.52502 5.06501 9.50836 5.77838 10.2217C6.49175 10.9351 7.4751 11.375 8.56261 11.375C10.7372 11.375 12.5001 9.61212 12.5001 7.4375C12.5001 5.26288 10.7372 3.5 8.56261 3.5ZM3.12511 7.4375C3.12511 4.43445 5.55957 2 8.56261 2C11.5657 2 14.0001 4.43445 14.0001 7.4375C14.0001 10.4405 11.5657 12.875 8.56261 12.875C7.33185 12.875 6.19579 12.4654 5.28463 11.7761L2.56066 14.5L1.5 13.4393L4.22397 10.7155C3.53468 9.80432 3.12511 8.66826 3.12511 7.4375Z"
        fill="currentColor"
      />
    </g>
  )
});
